/**
 * 格式化时间
 * 
 * @param {String} str
 * @returns 格式化后的时间
 */
export const formatDate = (str) => {
	if (!str) return ''
	var date = new Date(str)
	var time = new Date().getTime() - date.getTime() //现在的时间-传入的时间 = 相差的时间（单位 = 毫秒）
	if (time < 0) {
		return ''
	} else if ((time / 1000 < 30)) {
		return '刚刚'
	} else if (time / 1000 < 60) {
		return parseInt((time / 1000)) + '秒前'
	} else if ((time / 60000) < 60) {
		return parseInt((time / 60000)) + '分钟前'
	} else if ((time / 3600000) < 24) {
		return parseInt(time / 3600000) + '小时前'
	} else if ((time / 86400000) < 31) {
		return parseInt(time / 86400000) + '天前'
	} else if ((time / 2592000000) < 12) {
		return parseInt(time / 2592000000) + '月前'
	} else {
		return parseInt(time / 31536000000) + '年前'
	}
}

// 年月日
export function formatDateMin(secs) {
  var t = new Date(secs)
  var year = t.getFullYear()
  var month = t.getMonth() + 1
  if (month < 10) {
    month = '0' + month
  }
  var date = t.getDate()
  if (date < 10) {
    date = '0' + date
  }
  var hour = t.getHours()
  if (hour < 10) {
    hour = '0' + hour
  }
  var minute = t.getMinutes()
  if (minute < 10) {
    minute = '0' + minute
  }
  var second = t.getSeconds()
  if (second < 10) {
    second = '0' + second
  }
  return year + '-' + month + '-' + date 
}

// 年月日时分
export function formatDateTime(secs) {
  var t = new Date(secs)
  var year = t.getFullYear()
  var month = t.getMonth() + 1
  if (month < 10) {
    month = '0' + month
  }
  var date = t.getDate()
  if (date < 10) {
    date = '0' + date
  }
  var hour = t.getHours()
  if (hour < 10) {
    hour = '0' + hour
  }
  var minute = t.getMinutes()
  if (minute < 10) {
    minute = '0' + minute
  }
  var second = t.getSeconds()
  if (second < 10) {
    second = '0' + second
  }
  return year + '-' + month + '-' + date + ' ' + hour + ':' + minute + ':' + second
}

//几天前
export const beforeformatDate = (str) => {
  if (!str) return ''
  var date = new Date(str * 86400000)
  var time = new Date().getTime() - date.getTime() //现在的时间-传入的时间 = 相差的时间（单位 = 毫秒）
  // console.log(time)
  var t = new Date(time)
  var year = t.getFullYear()
  var month = t.getMonth() + 1
  if (month < 10) {
    month = '0' + month
  }
  var date = t.getDate()
  if (date < 10) {
    date = '0' + date
  }
  return year + '-' + month + '-' + date
}

export const checkPhone = (phone) => {
  var phoneReg = /^1(3|4|5|7|8|9)\d{9}$/;
  return phoneReg.test(phone);
}



// WEBPACK FOOTER //
// ./src/util/filter.js